module.exports = __webpack_public_path__ + "img/signup_bg_webapp_1.548a0341.png";